export enum MarketingBlastStatus {
	UNSCHEDULED = 1,
	SCHEDULED = 2,
	SENT = 3,
	ERROR = 4,
	DELETED = 5,
	PENDINGSEND = 6,
	ARCHIVED = 7,
}
